import axios from "axios";
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL;

const commonHeaders = () => {
  const apiToken = JSON.parse(localStorage.getItem("authUser")) || "";
  return {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  };
};

// POST to main cross-sell endpoint (supports pagination and export_all flag)
export const getCrossSellAPI = async (payload) => {
  try {
    const headers = commonHeaders();
    const response = await axios.post(`${apiBaseUrl}/crossSellUpdatedPagination`, payload || {}, { headers });
    return response;
  } catch (error) {
    // rethrow so saga can catch
    throw error;
  }
};

export const getCityAPI = async () => {
  try {
    const headers = commonHeaders();
    const response = await axios.get(`${apiBaseUrl}/get-all-cites`, { headers });
    return response;
  } catch (error) {
    throw error;
  }
};

// This endpoint is used by your "Export To excel" feature (keeps existing behavior)
export const exportCrossSellReportAPI = async () => {
  try {
    const headers = commonHeaders();
    const response = await axios.post(`${apiBaseUrl}/crossSellExeclReport`, {}, { headers });
    return response;
  } catch (error) {
    throw error;
  }
};
